import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
} from "@mui/material";

export interface ItemTypeValue {
    container: boolean,
    file: boolean,
    tape: boolean,
}

export interface ItemTypeProps {
    value: ItemTypeValue;
    onChange: (value: ItemTypeValue) => void;
}

export default function ItemType(props: ItemTypeProps): JSX.Element {
    const { value, onChange } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange({ ...value, [event.target.name]: event.target.checked });
    };

    return (
        <FormControl component="fieldset" sx={{
            marginTop: 1,
            minWidth: 120,
        }}>
            <FormLabel component="legend" sx={{ color: "#000000", textAlign: "left"}}>Inventory type</FormLabel>
            <FormGroup row>
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.container} onChange={handleChange} name="container" />}
                    label="Carton"
                />
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.file} onChange={handleChange} name="file" />}
                    label="File"
                />
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.tape} onChange={handleChange} name="tape" />}
                    label="Tape"
                />
            </FormGroup>
        </FormControl>
    );
}
